import { Translate } from '@dreryk/react-common';

import { receptionServiceTranslationKeys } from '../translations';

import { StyledPlaceholderText } from './ReceptionServiceListEmptyPlaceholder.styled';

export const ReceptionServiceListEmptyPlaceholder = (): JSX.Element => {
   return (
      <StyledPlaceholderText testId={'noReceptionServices'}>
         <Translate>{receptionServiceTranslationKeys.extensions.calendar.receptionServiceList.placeholder}</Translate>
      </StyledPlaceholderText>
   );
};
